export default __webpack_public_path__ + "static/media/saqlain.565e9a83.jpg";